import React from "react";
import GameInstructionModal from "../GameInstructionModal";

const BlueRedRainDropModal = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Raindrop (Red/Blue)"
      gamePath="/userDashboard/game/red-and-blue-raindrop"
      icon="solar:cloud-rain-bold"
      instructions={[
        "Wear red and blue glasses.",
        "Move the white paddle at the bottom using your mouse / trackpad.",
        "Catch the falling red and blue drops on the paddle to prevent them from dropping off screen."
      ]}
      isBinocular={true}
    />
  );
};

export default BlueRedRainDropModal;
